import { useLayoutEffect } from 'react';

/**
 * IntersectionObserver で .visible を付与し hub-panel-animated を表示する。
 * useLayoutEffect で paint 前に observer を登録し、初回フラッシュを防ぐ。
 *
 * @param {string} selector - 例: '.hub-features .hub-panel-animated'
 * @param {unknown[]} deps - 再観測トリガー（products.length 等）
 * @param {string} [rootMargin='250px 0px -5% 0px']
 */
export function usePanelRevealObserver(selector, deps = [], rootMargin = '250px 0px -5% 0px') {
  useLayoutEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { root: null, rootMargin, threshold: 0.01 }
    );

    document.querySelectorAll(selector).forEach((panel) => observer.observe(panel));

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- selector/rootMargin は安定定数想定
  }, deps);
}

/**
 * 複数セレクタ・rootMargin をまとめて観測
 * @param {{ selector: string, rootMargin?: string }[]} configs
 * @param {unknown[]} deps
 */
export function useMultiPanelRevealObserver(configs, deps = []) {
  useLayoutEffect(() => {
    const observers = configs.map(({ selector, rootMargin = '250px 0px -5% 0px' }) => {
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              entry.target.classList.add('visible');
            }
          });
        },
        { root: null, rootMargin, threshold: 0.01 }
      );
      document.querySelectorAll(selector).forEach((panel) => observer.observe(panel));
      return observer;
    });

    return () => observers.forEach((observer) => observer.disconnect());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
